import React, { useEffect, useState } from 'react';

import { connect } from 'react-redux';

import { isEmpty, cloneDeep } from 'lodash';
import { parsePhoneNumber } from 'libphonenumber-js';

import BobModal from '../../../components/BobModal';

import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';

import * as ContactActions from '../../../actions/contactActions';

import * as classes from './UpdateSiteContactPhoneModal.module.css';

const useStyles = makeStyles((theme) => ({
    root: {
        width:    '100%',
        height:   '20rem',
        overflow: 'auto',
        outline:  '1px solid #c6c6c6'
    },
    text: {
        fontSize: '1.2rem'
    }
}));

const UpdateSiteContactPhoneModal = ({
    activeNavCompany,
    setUpdateSiteContactPhoneModalOpen,
    createClientContact,
    phoneState,
    onClose,
    updatedPhoneNumbers,
    assignedSites,
    updateContact,
    selectedContact,
    handleRoute,
    contactBody,
    ...props
}) => {
    const styles = useStyles();

    const [value, setValue] = useState(0);
    const [modalState, setModalState] = useState([]);
    const [selectedIndexes, setSelectedIndexes] = useState([1]);
    const [actions, setActions] = useState([]);

    useEffect(() => {
        if (!isEmpty(phoneState)) {
            let updatedModalState = [];
            phoneState.forEach(item => {
                if (item.operation === 'Create') {
                    if (updatedPhoneNumbers.find(number => number.new.id === item.phoneId)) {
                        return;
                    } else {
                        updatedModalState.push(item);
                    }
                } else if (item.operation === 'Delete') {
                    if (updatedPhoneNumbers.find(number => number.old.id === item.userAssignmentPhoneId)) {
                        return;
                    } else {
                        updatedModalState.push(item);
                    }
                }
            });
            updatedPhoneNumbers.forEach(item => {
                const body = {
                    operation:   'Update',
                    phoneNumber: {
                        number: item.new.phoneNumber
                    },
                    ...item
                };
                updatedModalState.push(body);
            });
            setModalState(updatedModalState);
        }
    }, [phoneState]);

    const handleChange = (event, newValue) => {
        const updatedSelectedIndexes = [...selectedIndexes];
        if (!updatedSelectedIndexes.find(item => item === newValue + 1)) {
            updatedSelectedIndexes.push(newValue + 1);
            setSelectedIndexes(updatedSelectedIndexes);
        }
        setValue(newValue);
    };

    const handleSubmit = async () => {
        let items = [];

        actions.forEach(action => {
            //Create phone numbers
            if (action.operation === 'Create') {
                let found = items.findIndex(promise => promise.id === action.id);
                if (found > -1) {
                    items[found].phoneNumbers.push(modalState[action.index]);
                } else {
                    const number = modalState[action.index].operation === 'Update' ? modalState[action.index].new : modalState[action.index];
                    number.operation = 'Create';
                    number.primary = action.userAssignmentPhones.length === 0 && modalState[action.index].isPrimary;
                    number.SMS = modalState[action.index].isSMS;

                    const address = action.userAssignmentAddresses[0].address;
                    delete address.id;

                    const body = {
                        id:                   action.id,
                        addresses:            [{ address: address, isPrimary: true, userAssignmentAddressId: action.userAssignmentAddresses[0].id }],
                        autoIncudeSite:       false,
                        clientAndSiteContact: false,
                        clientId:             action.client.id,
                        email:                action.email,
                        firstName:            action.userName.FirstName,
                        lastName:             action.userName.LastName,
                        phoneNumbers:         [number],
                        siteId:               action.siteId,
                        title:                action.userAttributes.title
                    };
                    items.push(body);
                }
            } else if (action.operation === 'Delete') {
                let found = items.findIndex(promise => promise.id === action.id);

                if (found > -1) {
                    items[found].phoneNumbers.push(modalState[action.index]);
                } else {
                    const number = { ...modalState[action.index] };
                    number.operation = 'Delete';

                    const siteContactNumber = action.userAssignmentPhones.find(phone => phone.phoneNumber.id === number.phoneId);
                    number.UserAssignmentPhoneId = siteContactNumber.id;

                    const address = action.userAssignmentAddresses[0].address;
                    delete address.id;

                    const body = {
                        id:                   action.id,
                        addresses:            [{ address: address, isPrimary: true, userAssignmentAddressId: action.userAssignmentAddresses[0].id }],
                        autoIncudeSite:       false,
                        clientAndSiteContact: false,
                        clientId:             action.client.id,
                        email:                action.email,
                        firstName:            action.userName.FirstName,
                        lastName:             action.userName.LastName,
                        phoneNumbers:         [number],
                        siteId:               action.siteId,
                        title:                action.userAttributes.title
                    };
                    items.push(body);
                }
            //Update Numbers
            } else if (action.operation === 'Update') {
                const clonedState = cloneDeep(modalState);
                const oldNumber = clonedState[action.index].old;
                oldNumber.operation = 'Delete';

                const oldPhoneId = action.userAssignmentPhones.find(item => item.phoneNumber.id === oldNumber.phoneId);
                oldNumber.UserAssignmentPhoneId = oldPhoneId.id;

                const newNumber = modalState[action.index].new;
                newNumber.operation = 'Create';
                newNumber.primary = oldPhoneId.isPrimary;

                let found = items.findIndex(promise => promise.id === action.id);
                if (found > -1) {
                    items[found].phoneNumbers.push(oldNumber);
                    items[found].phoneNumbers.push(newNumber);
                } else {
                    const address = action.userAssignmentAddresses[0].address;
                    delete address.id;

                    const body = {
                        id:                   action.id,
                        addresses:            [{ address: address, isPrimary: true, userAssignmentAddressId: action.userAssignmentAddresses[0].id }],
                        autoIncudeSite:       false,
                        clientAndSiteContact: false,
                        clientId:             action.client.id,
                        email:                action.email,
                        firstName:            action.userName.FirstName,
                        lastName:             action.userName.LastName,
                        phoneNumbers:         [],
                        siteId:               action.siteId,
                        title:                action.userAttributes.title
                    };
                    body.phoneNumbers.push(oldNumber);
                    body.phoneNumbers.push(newNumber);
                    items.push(body);
                }
            }
        });

        let promises = [];

        items.forEach(item => {
            item.phoneNumbers.forEach(number => {
                number.isPrimary = number.primary || false;
                number.isSMS = number.SMS || false;
                number.phoneNumber = { number: number.phoneNumber, extension: number.extension, phoneType: number.phoneType };
            });
            promises.push(updateContact(item.id, item));
        });

        await Promise.all(promises.map(p => p.catch(err => err)));

        const isCreated = isEmpty(selectedContact) ? await createClientContact(activeNavCompany.id, contactBody) : await updateContact(selectedContact.id, contactBody);

        if (isCreated) {
            handleRoute();
        }
    };

    const handleSelectSiteContact = (item, index, operation) => {
        const updatedState = [...actions];
        const found = updatedState.findIndex(promise => promise.id === item.id && promise.index === index && promise.operation === operation);

        if (found > -1) {
            updatedState.splice(found, 1);
        } else {
            updatedState.push({ ...item, index, operation });
        }

        setActions(updatedState);
    };

    const renderCheckedState = (item, index, operation) => {
        const found = actions.findIndex(promise => promise.id === item.id && promise.index === index && promise.operation === operation);
        if (found > -1) {
            return true;
        }
        return false;
    };

    const renderListPanel = index => {
        if (isEmpty(modalState)) return null;

        if (modalState[index].operation === 'Create') {
            let number = renderFormattedNumber(modalState[index].phoneNumber.number);

            const availableContacts = [];

            assignedSites.forEach(item => {
                if (!item.userAssignmentPhones.find(number => number.phoneNumber.id === modalState[index].phoneId)) {
                    availableContacts.push(item);
                }
            });

            return (
                <div className={classes.Body}>
                    <div className={classes.Description}>
                        Create <span className={classes.Bold}>{number}</span> on the following Site Contacts:
                    </div>
                    <div className={classes.ListContainer}>
                        <List className={styles.root}>
                            {
                                availableContacts.map((item, i) => {
                                    return (
                                        <ListItem
                                            key={i}
                                            onClick={() => handleSelectSiteContact(item, index, 'Create')}
                                            role={undefined}
                                            dense
                                            button
                                        >
                                            <ListItemIcon>
                                                <Checkbox
                                                    checked={renderCheckedState(item, index, 'Create')}
                                                    style={{
                                                        color: 'black',
                                                    }}
                                                    edge="start"
                                                    tabIndex={-1}
                                                    disableRipple
                                                />
                                            </ListItemIcon>
                                            <ListItemText classes={{ primary: styles.text }} id={0} primary={item.name} />
                                        </ListItem>
                                    );
                                })
                            }
                        </List>
                    </div>
                </div>
            );
        } else if (modalState[index].operation === 'Update') {
            //let number = renderFormattedNumber(phoneState[index]);
            const oldNumber = renderFormattedNumber(modalState[index].old.phoneNumber);
            const newNumber = renderFormattedNumber(modalState[index].new.phoneNumber);
            let updates = [];
            let creates = [];

            assignedSites.forEach(item => {
                if (item.userAssignmentPhones.find(number => number.phoneNumber.id === modalState[index].old.phoneId)) {
                    updates.push(item);
                } else {
                    if (!item.userAssignmentPhones.find(number => number.phoneNumber.id === modalState[index].new.phoneId)) {
                        creates.push(item);
                    }
                }
            });

            return (
                <div className={classes.Body}>
                    <div className={classes.Description}>
                        Update <span className={classes.Bold}>{oldNumber}</span> with <span className={classes.Bold}>{newNumber}</span> on the following Site Contacts:
                    </div>
                    <div className={classes.ListContainer}>
                        <List className={styles.root}>
                            {
                                updates.map((item, i) => {
                                    return (
                                        <ListItem
                                            onClick={() => handleSelectSiteContact(item, index, 'Update')}
                                            key={i}
                                            role={undefined}
                                            dense
                                            button
                                        >
                                            <ListItemIcon>
                                                <Checkbox
                                                    checked={renderCheckedState(item, index, 'Update')}
                                                    style={{
                                                        color: 'black',
                                                    }}
                                                    edge="start"
                                                    tabIndex={-1}
                                                    disableRipple
                                                />
                                            </ListItemIcon>
                                            <ListItemText classes={{ primary: styles.text }} id={i} primary={item.name} />
                                        </ListItem>
                                    );
                                })
                            }
                        </List>
                    </div>
                    <div className={classes.SecondDescription}>
                        Create <span className={classes.Bold}>{newNumber}</span> on the following Site Contacts:
                    </div>
                    <div className={classes.ListContainer}>
                        <List className={styles.root}>
                            {
                                creates.map((item, i) => {
                                    return (
                                        <ListItem
                                            onClick={() => handleSelectSiteContact(item, index, 'Create')}
                                            key={i}
                                            role={undefined}
                                            dense
                                            button
                                        >
                                            <ListItemIcon>
                                                <Checkbox
                                                    checked={renderCheckedState(item, index, 'Create')}
                                                    style={{
                                                        color: 'black',
                                                    }}
                                                    edge="start"
                                                    tabIndex={-1}
                                                    disableRipple
                                                />
                                            </ListItemIcon>
                                            <ListItemText classes={{ primary: styles.text }} id={i} primary={item.name} />
                                        </ListItem>
                                    );
                                })
                            }
                        </List>
                    </div>
                </div>
            );
        } else {
            const availableContacts = [];

            assignedSites.forEach(item => {
                if (item.userAssignmentPhones.find(number => number.phoneNumber.id === modalState[index].phoneId)) {
                    availableContacts.push(item);
                }
            });

            return (
                <div className={classes.Body}>
                    <div className={classes.Description}>
                        Delete <span className={classes.Bold}>{'Number'}</span> on the following Site Contacts:
                    </div>
                    <div className={classes.ListContainer}>
                        <List className={styles.root}>
                            {
                                availableContacts.map((item, i) => {
                                    return (
                                        <ListItem
                                            key={i}
                                            onClick={() => handleSelectSiteContact(item, index, 'Delete')}
                                            role={undefined}
                                            dense
                                            button
                                        >
                                            <ListItemIcon>
                                                <Checkbox
                                                    checked={renderCheckedState(item, index, 'Delete')}
                                                    style={{
                                                        color: 'black',
                                                    }}
                                                    edge="start"
                                                    tabIndex={-1}
                                                    disableRipple
                                                />
                                            </ListItemIcon>
                                            <ListItemText classes={{ primary: styles.text }} id={i} primary={item.name} />
                                        </ListItem>
                                    );
                                })
                            }
                        </List>
                    </div>
                </div>
            );
        }
    };

    const renderFormattedNumber = item => {
        let number = item;
        if (number && number.charAt(0) !== '+') {
            number = '+' + number;
        }
        number = parsePhoneNumber(number);
        if (number) number = number.formatInternational();
        return number;
    };

    const renderTabLabel = (item, index) => {
        const number = renderFormattedNumber(item.phoneNumber.number);
        const showIcon = !selectedIndexes.find(item => item === index + 1);

        return <span>{number}{showIcon ? <span className={classes.UnreadIcon} /> : null}</span>;
    };

    return (
        <BobModal
            title="Update Site Contacts"
            confirmText="Ok"
            onClose={() => setUpdateSiteContactPhoneModalOpen(false)}
            onConfirm={handleSubmit}
        >
            <Tabs
                TabIndicatorProps={{ style: { background: 'black' } }}
                value={value}
                onChange={handleChange}
            >
                {
                    modalState.map((item, index) => {
                        return (
                            <Tab className={classes.Tab} value={index} label={renderTabLabel(item, index)} />
                        );
                    })
                }
            </Tabs>
            <div>
                {renderListPanel(value)}
            </div>
        </BobModal>
    );
};

const mapStateToProps = state => {
    return {
        activeNavCompany: state.bob.activeNavCompany,
    };
};

const mapDispatchToProps = {
    ...ContactActions
};

export default connect(mapStateToProps, mapDispatchToProps)(UpdateSiteContactPhoneModal);
